import { Box, Button, Container, Typography } from "@mui/material";
import { onSnapshot, query, where } from "firebase/firestore";
import { filter, map, sortBy } from "lodash";
import { useEffect, useState } from "react";
import UsuarioDb from "../../../../db/usuarioDb";
import Business from "../../../../models/business";
import Usuario from "../../../../models/usuario";
import TabelaClientes from "../../../util/tabelas/tabelaClientes";
import { IconUserPlus } from "@tabler/icons-react";
import CriarClienteDialog from "./criarClienteDialog";

type Props = { business: Business };

export default function Clientes({ business }: Props) {
  const [clientes, setClientes] = useState<Usuario[]>([]);
  const [openCriarCliente, setOpenCriarCliente] = useState(false);

  useEffect(() => {
    return onSnapshot(
      query(
        new UsuarioDb().collection({ usuarioId: "" }),
        where("contaPai", "==", business.id)
      ),
      (query) => {
        setClientes(
          sortBy(
            map(query.docs, (doc) => doc.data()),
            (c) => (!!c.arquivado ? 1 : 0),
            "nome"
          )
        );
      }
    );
  }, [business]);

  return (
    <Container sx={{ mt: 3, mb: 2, ml: 0 }} disableGutters maxWidth="md">
      <Box
        display="flex"
        flexDirection="row"
        width="100%"
        justifyContent="flex-start"
        alignItems="center"
        mb={2}
      >
        {/* Section header numerado: NN em mono + nome na Mabry (DESIGN.md). */}
        <Box display="flex" alignItems="baseline" gap={1.5}>
          <Typography variant="eyebrow" color="text.secondary">
            01
          </Typography>
          <Typography variant="h3" color="text.primary">
            Clientes
          </Typography>
        </Box>
        <Box flexGrow={1} />
        {/* Contador de contas: mono tabular para não dançar quando muda. */}
        <Typography
          variant="dataMono"
          mr={2}
          component="span"
          color="text.secondary"
        >
          <Typography
            variant="dataMono"
            fontWeight={500}
            component="span"
            color={
              filter(clientes, (c) => !c.arquivado).length > business.quantidade
                ? "error.main"
                : "text.primary"
            }
          >
            {filter(clientes, (c) => !c.arquivado).length}
          </Typography>
          {`/${business.quantidade}`}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<IconUserPlus size={18} />}
          onClick={() => setOpenCriarCliente(true)}
          disabled={
            business.quantidade <=
            clientes.filter((cliente) => !!!cliente.arquivado).length
          }
        >
          Adicionar cliente
        </Button>
        <CriarClienteDialog
          business={business}
          open={openCriarCliente}
          onClose={() => setOpenCriarCliente(false)}
        />
      </Box>
      <TabelaClientes clientes={clientes} />
    </Container>
  );
}
